import React, { useState, useRef, useEffect } from 'react';
import avatar from 'assets/images/aaa.jpg';
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { logout } from 'units/auth/store/authSlice';
import logoutUser from '../services/userLogout';
import { LogOut, ChevronDown, Wallet, Sun, Moon, Check, Globe } from 'lucide-react';
import { AiFillFund } from 'react-icons/ai';
import { MdGridView } from 'react-icons/md';
import { useTheme } from 'units/dashboard/context/ThemeProvider';
import { useLanguage } from 'units/dashboard/context/LanguageProvider';

const ProfileDropDown = ({ userType, wallet = 0, income = 0, isPlanActive = false }) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.userInfo);
    const profileName = `${user?.firstName || ""} ${user?.lastName || ""}`.trim();
    const finalName = user?.orgName?.trim() || profileName || "مدیر محترم";
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isLangOpen, setIsLangOpen] = useState(false);
    const wrapperRef = useRef(null);

    const { theme, toggleTheme } = useTheme();
    const { lang, setLang, languages } = useLanguage();

    const toggleDropdown = () => setIsDropdownOpen((s) => !s);

    const displayName =
        userType === 2
            ? "ادمین محترم"
            : userType === 1
                ? finalName
                : "کاربر";

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
                setIsLangOpen(false);
            }
        };
        if (isDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isDropdownOpen]);

    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape') {
                setIsDropdownOpen(false);
                setIsLangOpen(false);
            }
        };
        if (isDropdownOpen) document.addEventListener('keydown', handleEsc);
        return () => document.removeEventListener('keydown', handleEsc);
    }, [isDropdownOpen]);

    const handleLogout = async () => {
        try {
            const accessToken = localStorage.getItem("accessToken");
            if (accessToken) {
                await logoutUser(accessToken);
            }
        } catch (error) {
            console.error("Logout request failed:", error);
        } finally {
            dispatch(logout());
        }
    };

    return (
        <div className="relative inline-flex" ref={wrapperRef}>
            {/* Trigger button */}
            <button
                type="button"
                className="
                    group flex items-center gap-2
                    h-[42px] px-2 sm:px-3
                    rounded-xl
                    bg-white/5 hover:bg-white/10
                    border border-white/10 hover:border-amber-300/40
                    backdrop-blur-md
                    transition-colors duration-300 ease-out
                    hover:shadow-[0_0_20px_-6px_rgba(251,191,36,0.5)]
                    active:scale-95
                    dark:!bg-white/5 dark:!hover:bg-white/10
                    shrink-0
                "
                id="page-header-user-dropdown"
                onClick={toggleDropdown}
                aria-haspopup="true"
                aria-expanded={isDropdownOpen}
            >
                <span className="relative shrink-0 rounded-full p-[1.5px] bg-gradient-to-br from-amber-300 via-teal-300 to-amber-400 shadow-[0_0_12px_-2px_rgba(251,191,36,0.6)] transition-shadow duration-500 group-hover:shadow-[0_0_18px_-2px_rgba(251,191,36,0.9)]">
                    <img
                        className="h-7 w-7 sm:h-8 sm:w-8 rounded-full object-cover border-2 border-[#0F3B3C] dark:!border-slate-900"
                        src={avatar}
                        alt="Header Avatar"
                    />
                    <span className="absolute -bottom-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-emerald-400 border-2 border-[#0F3B3C] dark:!border-slate-900 shadow-[0_0_6px_rgba(16,185,129,0.9)]" />
                </span>

                <span className="hidden sm:block text-[11px] md:text-xs font-semibold text-white/90 group-hover:text-amber-100 transition-colors duration-300 whitespace-nowrap max-w-[120px] truncate">
                    {displayName}
                </span>

                <ChevronDown
                    size={16}
                    className={`
                        hidden xl:block text-amber-200/80 group-hover:text-amber-200
                        transition-transform duration-300 shrink-0
                        ${isDropdownOpen ? 'rotate-180' : 'rotate-0'}
                    `}
                />
            </button>

            {/* Dropdown menu */}
            <div
                className={`
                    absolute top-full mt-3 z-50
                    ltr:right-0 rtl:left-0
                    w-64
                    list-none rounded-2xl
                    backdrop-blur-xl
                    bg-gradient-to-b from-[#0F3B3C]/95 to-[#134E4F]/95
                    dark:!from-slate-900/95 dark:!to-slate-800/95
                    border border-teal-400/30 dark:!border-teal-400/20
                    shadow-[0_10px_40px_-10px_rgba(0,0,0,0.7),0_0_30px_-10px_rgba(45,212,191,0.4)]
                    origin-top
                    transition-[opacity,transform] duration-200 ease-out
                    ${isDropdownOpen
                        ? 'opacity-100 scale-100 translate-y-0 pointer-events-auto visible'
                        : 'opacity-0 scale-95 -translate-y-1 pointer-events-none invisible'
                    }
                `}
                role="menu"
            >
                <div className="h-[2px] w-full bg-gradient-to-l from-transparent via-amber-400/80 to-transparent rounded-t-2xl" />

                {/* ============= وضعیت حساب — فقط موبایل ============= */}
                {userType == 1 && (
                    <div className="sm:hidden p-1.5 border-b border-teal-400/15">
                        <div className="flex items-center justify-between px-3 py-2 rounded-xl text-xs font-semibold text-amber-100">
                            <span className="flex items-center gap-2 opacity-80">
                                <AiFillFund className="h-3.5 w-3.5 text-amber-300" />
                                درآمد
                            </span>
                            <span className="font-bold text-amber-200">
                                {income.toLocaleString('fa-IR')} ریال
                            </span>
                        </div>

                        <div className="flex items-center justify-between px-3 py-2 rounded-xl text-xs font-semibold text-teal-100">
                            <span className="flex items-center gap-2 opacity-80">
                                <Wallet className="h-3.5 w-3.5 text-teal-300" />
                                کیف پول
                            </span>
                            <span className="font-bold text-teal-200">
                                {wallet.toLocaleString('fa-IR')} ریال
                            </span>
                        </div>

                        <div className="flex items-center justify-between px-3 py-2 rounded-xl text-xs font-semibold">
                            <span className={`flex items-center gap-2 opacity-80 ${isPlanActive ? "text-emerald-100" : "text-rose-100"}`}>
                                <MdGridView size={14} />
                                وضعیت طرح
                            </span>
                            <span className="flex items-center gap-1.5">
                                <span className="relative flex h-2 w-2 shrink-0">
                                    <span className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${isPlanActive ? "bg-emerald-300" : "bg-rose-300"}`} />
                                    <span className={`relative inline-flex rounded-full h-full w-full ${isPlanActive ? "bg-emerald-300" : "bg-rose-300"}`} />
                                </span>
                                <span className={`font-bold ${isPlanActive ? "text-emerald-200" : "text-rose-200"}`}>
                                    {isPlanActive ? "فعال" : "غیرفعال"}
                                </span>
                            </span>
                        </div>
                    </div>
                )}

                {/* ============= تنظیمات: تم و زبان ============= */}
                <div className="p-1.5 border-b border-teal-400/15 space-y-1">
                    {/* تم */}
                    <button
                        type="button"
                        onClick={toggleTheme}
                        className="
                            w-full flex items-center justify-between
                            px-3 py-2.5 rounded-xl
                            text-xs font-semibold
                            text-teal-50/90 hover:text-amber-100
                            hover:bg-white/5
                            transition-colors duration-300
                        "
                        role="menuitem"
                    >
                        <span className="flex items-center gap-2.5">
                            {theme === "dark" ? (
                                <Moon size={16} className="text-teal-300 shrink-0" />
                            ) : (
                                <Sun size={16} className="text-amber-300 shrink-0" />
                            )}
                            حالت نمایش
                        </span>
                        <span className="text-[11px] opacity-70">
                            {theme === "dark" ? "تاریک" : "روشن"}
                        </span>
                    </button>

                    {/* زبان */}
                    <div className="relative">
                        <button
                            type="button"
                            onClick={() => setIsLangOpen((s) => !s)}
                            className="
                                w-full flex items-center justify-between
                                px-3 py-2.5 rounded-xl
                                text-xs font-semibold
                                text-teal-50/90 hover:text-amber-100
                                hover:bg-white/5
                                transition-colors duration-300
                            "
                            role="menuitem"
                        >
                            <span className="flex items-center gap-2.5">
                                <Globe size={16} className="text-teal-300 shrink-0" />
                                زبان
                            </span>
                            <span className="flex items-center gap-1 text-[11px] opacity-70">
                                {languages.find((l) => l.code === lang)?.label}
                                <ChevronDown
                                    size={12}
                                    className={`transition-transform duration-200 ${isLangOpen ? 'rotate-180' : ''}`}
                                />
                            </span>
                        </button>

                        {isLangOpen && (
                            <div className="mt-1 mr-1 ml-1 rounded-xl bg-black/15 overflow-hidden">
                                {languages.map((option) => {
                                    const isSelected = lang === option.code;
                                    return (
                                        <button
                                            key={option.code}
                                            type="button"
                                            onClick={() => {
                                                setLang(option.code);
                                                setIsLangOpen(false);
                                            }}
                                            className={`
                                                w-full flex items-center justify-between
                                                px-3 py-2 text-xs font-medium
                                                transition-colors duration-200
                                                ${isSelected
                                                    ? "text-amber-200 bg-amber-400/10"
                                                    : "text-teal-50/80 hover:bg-white/5 hover:text-amber-100"
                                                }
                                            `}
                                        >
                                            <span>{option.label}</span>
                                            {isSelected && <Check size={14} />}
                                        </button>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>

                {/* ============= خروج ============= */}
                <div className="p-1.5">
                    <Link
                        onClick={handleLogout}
                        to="/login"
                        className="
                            group/item flex items-center gap-2.5
                            px-3 py-2.5 rounded-xl
                            text-xs font-semibold
                            text-rose-100/90 hover:text-rose-50
                            bg-transparent hover:bg-rose-500/15
                            border border-transparent hover:border-rose-400/40
                            transition-colors duration-300
                        "
                        role="menuitem"
                    >
                        <LogOut
                            size={16}
                            className="text-rose-300/90 group-hover/item:text-rose-200 transition-colors duration-300 shrink-0"
                        />
                        <span>خروج از حساب</span>
                    </Link>
                </div>

                <div className="pointer-events-none absolute -bottom-4 left-1/2 -translate-x-1/2 h-8 w-32 rounded-full bg-teal-400/20 blur-2xl dark:!bg-teal-400/10" />
            </div>
        </div>
    );
};

export default ProfileDropDown;